import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { isMobile } from '../../../utils/utils';

interface Producto {
  id: number;
  attributes: Record<string, unknown>;
}

const useHook = () => {

  const [mobile, setMobile] = useState(true);

  // productos
  const [productos, setProductos] = useState<Producto[]>([]);
  const [loadingProductos, setLoadingProductos] = useState(true);

  const productosFavoritos = useSelector((state: { favoritos: { productos: Producto[] } }) => state.favoritos.productos);

  useEffect(() => {
    setMobile(isMobile());
  }, []);

  useEffect(() => {
    // Se re-sincroniza con `productosFavoritos` para reflejar en el momento
    // si el usuario saca un producto de favoritos desde esta misma página.
    setProductos(productosFavoritos);
    setLoadingProductos(false);
  }, [productosFavoritos]);

  return {
    mobile,
    loadingProductos,
    productos,
  };
};

export default useHook;
